var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"skewed-header"},[_c('div',{staticClass:"header-bg",style:(_vm.bgImage)}),_c('div',{staticClass:"skewed-header-wrapper"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }